import { Link } from 'react-router-dom'
import { Document } from '@/types'
import { getDocumentUrl } from '@/utils/helpers'
import './FeaturedDocuments.css'

interface FeaturedDocumentsProps {
  documents: Document[]
}

function FeaturedDocuments({ documents }: FeaturedDocumentsProps) {
  if (documents.length === 0) {
    return null
  }

  const getCategoryLabel = (category: string) => {
    const labels: { [key: string]: string } = {
      flyers: 'Tract',
      programme: 'Programme',
      communiques: 'Communiqué',
      autres: 'Document'
    }
    return labels[category] || 'Document'
  }

  const getCategoryIcon = (category: string) => {
    const icons: { [key: string]: string } = {
      flyers: '📄',
      programme: '📋',
      communiques: '📢',
      autres: '📁'
    }
    return icons[category] || '📁'
  }

  return (
    <section className="featured-documents">
      <div className="container">
        <h2 className="section-title">Documents clés</h2>
        <p className="section-subtitle">
          Consultez notre programme et nos propositions détaillées
        </p>

        <div className="documents-grid">
          {documents.map((document) => {
            const rawUrl = document.download_url || document.media?.file_path
            const documentUrl = rawUrl ? getDocumentUrl(rawUrl) : ''

            return (
              <div key={document.id} className="document-card">
                <div className="document-card-icon">
                  {getCategoryIcon(document.category)}
                </div>
                <div className="document-card-content">
                  <span className="document-card-category">
                    {getCategoryLabel(document.category)}
                  </span>
                  <h3 className="document-card-title">{document.title}</h3>
                  <p className="document-card-description">
                    {document.description}
                  </p>
                  {documentUrl && (
                    <a
                      href={documentUrl}
                      className="document-card-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Télécharger le document →
                    </a>
                  )}
                </div>
              </div>
            )
          })}
        </div>

        <div className="section-cta">
          <Link to="/le-projet" className="btn btn-primary">
            Découvrir tous les documents
          </Link>
        </div>
      </div>
    </section>
  )
}

export default FeaturedDocuments
